import { Box, InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { SectionCard } from '../../ui/primitives';

const fields = [
  {
    label: 'TFN withholding rate',
    value: '47',
    unit: '%',
    help: 'Top marginal rate plus Medicare levy',
  },
  { label: 'Non-resident interest withholding', value: '10', unit: '%' },
  { label: 'KYC refresh (low risk)', value: '36', unit: 'months' },
  { label: 'KYC refresh (high risk / PEP)', value: '12', unit: 'months' },
  { label: 'Wholesale certificate warning', value: '60', unit: 'days before expiry' },
  { label: 'Payment hold after bank change', value: '48', unit: 'hours' },
  { label: 'Capital call minimum notice', value: '10', unit: 'business days' },
  { label: 'Call reminder schedule', value: '7, 3, 1', unit: 'days before due' },
  { label: 'Application cut-off for month-end issue', value: '2', unit: 'business days' },
  { label: 'Record retention', value: '7', unit: 'years' },
];

export default function RulesTab() {
  return (
    <SectionCard
      title="Registry rules"
      subtitle="Defaults for every fund; individual funds can override some of these"
    >
      <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' } }}>
        {fields.map((field) => (
          <TextField
            key={field.label}
            label={field.label}
            defaultValue={field.value}
            helperText={field.help}
            InputProps={{
              endAdornment: <InputAdornment position="end">{field.unit}</InputAdornment>,
            }}
          />
        ))}
      </Box>
    </SectionCard>
  );
}
